// controllers/userController.js
import {  serverTimestamp, where, orderBy, limit, startAfter, query, getDocs, updateDoc, getDoc, doc, collection } from "firebase/firestore";
import { usersCollection, userDoc } from "../models/userModel.js";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth, db } from "../../firebase/firebase.js";


export const getAllUsers = async ({
  limitCount = 10,
  sortBy = "lastModifiedTimestamp",
  searchKey = "",
  startAfterdoc = null
}) => {
  let queryConstraints = [];

  if (searchKey) {
    queryConstraints.push(
      where("searchKey", ">=", searchKey),
      where("searchKey", "<=", searchKey + "\uf8ff")
    );
  }


  queryConstraints.push(orderBy(sortBy, "desc"));
  queryConstraints.push(limit(limitCount));

  if (startAfterdoc) {
const startRef = doc(db, "users", startAfterdoc);
const startSnap = await getDoc(startRef);
    queryConstraints.push(startAfter(startSnap));
  }

  const baseQuery = query(usersCollection, ...queryConstraints);

  const snapshot = await getDocs(baseQuery);

  const users = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  return {
    users,
    firstVisible: snapshot.docs[0],
    lastVisible: snapshot.docs[snapshot.docs.length - 1] || null,
  };
};


// export const loginUser = async (data) => {
//   try {
//     const { emailId: email, password } = data;

//     // Check if user exists and is active and only admin can access other wise send your are unauthorized to login
//     const userQuery = query(
//       usersCollection,
//       where("emailId", "==", email),
//       where("role", "==", "ADMIN"),
//       where("status", "==", true)
//     );

//     const userSnapshot = await getDocs(userQuery);

//     if (userSnapshot.empty) {
//       throw new Error("User not found or inactive");
//     }

//     const userDoc = userSnapshot.docs[0];
//     const userData = userDoc.data();

//     const userCredential = await signInWithEmailAndPassword(auth, email, password);

//     const authUser = userCredential.user;


//     return {
//       id: userDoc.id,
//       ...userData,
//     };
//   } catch (error) {
//     console.error("Login error:", error.message);
//     throw new Error(error.message || "Login failed");
//   }
// };

// OE
// export const loginUser = async (data) => {
//   try {
//     const { emailId: email, password } = data;

//     if (!email || !password) {
//       throw new Error("Email and password are required");
//     }

//     // Step 1: Sign in using Firebase Auth
//     const userCredential = await signInWithEmailAndPassword(auth, email, password);
//     const authUser = userCredential.user;

//     // Step 2: Check Firestore for admin and active status
//     const userQuery = query(
//       usersCollection,
//       where("emailId", "==", authUser.email),
//       where("role", "==", "ADMIN"),
//       where("status", "==", true)
//     );

//     const userSnapshot = await getDocs(userQuery);

//     if (userSnapshot.empty) {
//       await signOut(auth); // sign out if not authorized
//       throw new Error("You are not authorized to access this application");
//     }

//     const userDoc = userSnapshot.docs[0];
//     const userData = userDoc.data();

//  return {
//       id: userDoc.id,
//       ...userData,
//     };
//   } catch (error) {
//     console.error("Login error:", error.message);
//     throw new Error(error.message || "Login failed");
//   }
// };

// export const loginUser = async (data) => {
//   try {
//     const { emailId: email, password } = data;

//     // DEBUG: Log Firebase configuration
//     console.log('🔍 ==========================================');
//     console.log('🔍 FIREBASE CONFIGURATION DEBUG');
//     console.log('🔍 ==========================================');
//     console.log('Current URL:', window.location.href);
//     console.log('Firebase Project ID:', auth.app.options.projectId);
//     console.log('Firebase Auth Domain:', auth.app.options.authDomain);
//     console.log('Email attempting login:', email);

//     if (!email || !password) {
//       throw new Error("Email and password are required");
//     }

//     console.log('🚀 Step 1: Starting Firebase Authentication...');

//     // Step 1: Sign in using Firebase Auth
//     const userCredential = await signInWithEmailAndPassword(auth, email, password);
//     const authUser = userCredential.user;

//     console.log('✅ Step 1 SUCCESS: Firebase Authentication completed');
//     console.log('Authenticated User ID:', authUser.uid);
//     console.log('Authenticated User Email:', authUser.email);

//     console.log('🚀 Step 2: Starting Firestore query...');

//     // Step 2: Check Firestore for admin and active status
//     const userQuery = query(
//       usersCollection,
//       where("emailId", "==", authUser.email),
//       where("role", "==", "ADMIN"),
//       where("status", "==", true)
//     );

//     console.log('🔍 Firestore Query Details:');
//     console.log('- Collection: users');
//     console.log('- emailId ==', authUser.email);
//     console.log('- role == ADMIN');
//     console.log('- status == true');

//     const userSnapshot = await getDocs(userQuery);

//     console.log('🔍 Firestore Query Results:');
//     console.log('- Documents found:', userSnapshot.size);
//     console.log('- Query empty:', userSnapshot.empty);

//     if (userSnapshot.empty) {
//       console.log('❌ No matching admin user found in Firestore');
//       await signOut(auth);
//       throw new Error("You are not authorized to access this application");
//     }

//     const userDoc = userSnapshot.docs[0];
//     const userData = userDoc.data();

//     console.log('✅ Step 2 SUCCESS: Admin user found');
//     console.log('User Document ID:', userDoc.id);
//     console.log('User Data:', userData);
//     console.log('🎉 ==========================================');
//     console.log('🎉 LOGIN COMPLETED SUCCESSFULLY');
//     console.log('🎉 ==========================================');

//     return {
//       id: userDoc.id,
//       ...userData,
//     };
//   } catch (error) {
//     console.log('❌ ==========================================');
//     console.log('❌ LOGIN ERROR OCCURRED');
//     console.log('❌ ==========================================');
//     console.error("Error Type:", error.constructor.name);
//     console.error("Error Code:", error.code);
//     console.error("Error Message:", error.message);
//     console.error("Full Error Object:", error);
    
//     // Check if it's a specific Firebase error
//     if (error.code) {
//       console.error("Firebase Error Code:", error.code);
//     }
    
//     console.log('❌ ==========================================');
//     throw new Error(error.message || "Login failed");
//   }
// };\\


export const loginUser = async (data) => {
  try {
    const { emailId: email, password } = data;

    // COMPREHENSIVE DEBUG
    console.log('🔍 ==========================================');
    console.log('🔍 COMPREHENSIVE FIREBASE DEBUG');
    console.log('🔍 ==========================================');
    console.log('Current URL:', window.location.href);
    console.log('Current Domain:', window.location.hostname);
    
    // Check ALL environment variables
    console.log('🌍 Environment Variables:');
    console.log('NODE_ENV:', process.env.NODE_ENV);
    console.log('REACT_APP_ENVIRONMENT:', process.env.REACT_APP_ENVIRONMENT);
    console.log('REACT_APP_GIT_BRANCH:', process.env.REACT_APP_GIT_BRANCH);
    
    // Check Firebase Configuration in Detail
    console.log('🔥 Firebase App Configuration:');
    const firebaseConfig = auth.app.options;
    console.log('- Project ID:', firebaseConfig.projectId);
    console.log('- Auth Domain:', firebaseConfig.authDomain);
    console.log('- API Key (first 10 chars):', firebaseConfig.apiKey?.substring(0, 10) + '...');
    console.log('- App ID:', firebaseConfig.appId);
    console.log('- Storage Bucket:', firebaseConfig.storageBucket);
    console.log('- Messaging Sender ID:', firebaseConfig.messagingSenderId);
    
    // Check which environment branch detection is working
    const currentBranch = process.env.REACT_APP_GIT_BRANCH;
    const isProduction = currentBranch === 'main';
    console.log('🌿 Branch Detection:');
    console.log('- Current Branch:', currentBranch);
    console.log('- Is Production:', isProduction);
    console.log('- Is Dev Branch:', currentBranch === 'dev-scheduler');

    if (!email || !password) {
      throw new Error("Email and password are required");
    }

    console.log('🚀 Step 1: Starting Firebase Authentication...');
    console.log('Attempting login for email:', email);

    // Step 1: Firebase Authentication
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const authUser = userCredential.user;

    console.log('✅ Step 1 SUCCESS: Firebase Authentication completed');
    console.log('🔑 Authentication Results:');
    console.log('- Authenticated User ID:', authUser.uid);
    console.log('- Authenticated User Email:', authUser.email);
    console.log('- User Creation Time:', authUser.metadata.creationTime);
    console.log('- User Last Sign In:', authUser.metadata.lastSignInTime);
    
    // CRITICAL: Check which Firebase project this UID belongs to
    console.log('🆔 UID Analysis:');
    console.log('- UID Length:', authUser.uid.length);
    console.log('- UID First 10 chars:', authUser.uid.substring(0, 10));
    console.log('- Expected Dev UID: Should be different from production');

    // Check if this is the expected environment
    console.log('🎯 Environment Verification:');
    if (firebaseConfig.projectId === 'nfbd-scheduler-dev') {
      console.log('✅ Correct: Using Development Firebase Project');
    } else if (firebaseConfig.projectId === 'nfbd-scheduler-app') {
      console.log('❌ ERROR: Using Production Firebase Project!');
    } else {
      console.log('⚠️ WARNING: Using Unknown Firebase Project:', firebaseConfig.projectId);
    }

    console.log('🚀 Step 2: Starting Firestore query...');

    // Step 2: Firestore Query
    const userQuery = query(
      usersCollection,
      where("emailId", "==", authUser.email),
      where("role", "in", ["ADMIN", "SUPER_ADMIN"]),
      where("status", "==", true)
    );

    console.log('🔍 Firestore Query Details:');
    console.log('- Collection: users');
    console.log('- Database Project:', firebaseConfig.projectId);
    console.log('- Query Conditions:');
    console.log('  * emailId ==', authUser.email);
    console.log('  * role in [ADMIN, SUPER_ADMIN]');
    console.log('  * status == true');

    const userSnapshot = await getDocs(userQuery);

    console.log('🔍 Firestore Query Results:');
    console.log('- Documents found:', userSnapshot.size);
    console.log('- Query empty:', userSnapshot.empty);
    
    // If documents found, log their details
    if (!userSnapshot.empty) {
      userSnapshot.docs.forEach((doc, index) => {
        console.log(`📄 Document ${index + 1}:`, {
          id: doc.id,
          data: doc.data()
        });
      });
    }

    if (userSnapshot.empty) {
      console.log('❌ No matching admin/super-admin user found in Firestore');
      
      // Additional debug: Try to find ANY user with this email
      console.log('🔍 DEBUG: Searching for ANY user with this email...');
      const anyUserQuery = query(
        usersCollection,
        where("emailId", "==", authUser.email)
      );
      const anyUserSnapshot = await getDocs(anyUserQuery);
      console.log('- Any user with this email found:', anyUserSnapshot.size);
      
      if (!anyUserSnapshot.empty) {
        anyUserSnapshot.docs.forEach((doc, index) => {
          console.log(`📄 Found User ${index + 1}:`, doc.data());
        });
      }
      
      await signOut(auth);
      throw new Error("You are not authorized to access this application");
    }

    const userDoc = userSnapshot.docs[0];
    const userData = userDoc.data();

    console.log('✅ Step 2 SUCCESS: Admin/Super Admin user found');
    console.log('📄 User Document Details:');
    console.log('- Document ID:', userDoc.id);
    console.log('- User Data:', userData);
    console.log('🎉 ==========================================');
    console.log('🎉 LOGIN COMPLETED SUCCESSFULLY');
    console.log('🎉 ==========================================');

    return {
      id: userDoc.id,
      ...userData,
    };
  } catch (error) {
    console.log('❌ ==========================================');
    console.log('❌ LOGIN ERROR OCCURRED');
    console.log('❌ ==========================================');
    console.error("Error Type:", error.constructor.name);
    console.error("Error Code:", error.code);
    console.error("Error Message:", error.message);
    console.error("Full Error Object:", error);
    
    if (error.code) {
      console.error("Firebase Error Code:", error.code);
    }
    
    console.log('❌ ==========================================');
    throw new Error(error.message || "Login failed");
  }
};

export const updateUserById = async (id, updatedData) => {
  const userRef = userDoc(id);

 
  // Fetch existing user data
  const existingUserSnap = await getDoc(userRef);
  if (!existingUserSnap.exists()) {
    throw new Error("User not found.");
  }
  const existingUserData = existingUserSnap.data();

  // Only check for duplicate if phone number is changed
  if (
    updatedData.phoneNumber &&
    updatedData.phoneNumber !== existingUserData.phoneNumber
  ) {
    const phoneQuery = query(
      usersCollection,
      where("phoneNumber", "==", updatedData.phoneNumber)
    );
    const querySnapshot = await getDocs(phoneQuery);

    const isDuplicate = querySnapshot.docs.some(doc => doc.id !== id);
    if (isDuplicate) {

      const err = new Error("Phone number already exists.");
  err.code = "DUPLICATE_PHONE";
  throw err;
    }
  }

  const dataToUpdate = {
    ...updatedData,
    modifiedBy: userDoc(updatedData.modifiedBy),
    lastModifiedTimestamp: serverTimestamp(),
  };
  await updateDoc(userRef, dataToUpdate);
};

export const getRoleBasedUsers = async () => {
  const baseQuery = query(usersCollection, where("role", "!=", "ADMIN" ), where("status", "==", true));
  const snapshot = await getDocs(baseQuery);

  const users = snapshot.docs.map((doc) => {
    const data = doc.data();
    return {
      id: doc.id,
      name: data.name || "Unnamed",
    };
  });

  return users;
};


export const getContactPersons = async () => {
  const contactPersonsRef = collection(db, "contactPersons");
  const snapshot = await getDocs(contactPersonsRef);

  const contactPersons = snapshot.docs.map((doc) => ({
    id: doc.id,
    name: doc.data().name || "",
  }));

  return contactPersons;
};
